import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";

import { useFocusEffect } from "@react-navigation/native";
import { useDebouncedCallback } from "use-debounce";

import { WIDGET_TODO_SUMMARY_PREVIEW_QUERY } from "./WidgetTodoSummaryPreview";
import {
  WidgetTodoSummaryPreviewQuery,
  WidgetTodoSummaryPreviewQuery$variables,
} from "./__generated__/WidgetTodoSummaryPreviewQuery.graphql";

export function useWidgetTodoSummaryPreviewQuery({
  storecastId,
  teamIds,
  todoCategoryId,
}: {
  storecastId: string;
  teamIds: string[];
  todoCategoryId: string;
}) {
  const [query, loadQuery] = useQueryLoader<WidgetTodoSummaryPreviewQuery>(
    WIDGET_TODO_SUMMARY_PREVIEW_QUERY
  );
  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[]) => {
      try {
        const variables: WidgetTodoSummaryPreviewQuery$variables = {
          storecastId,
          input: {
            size: "TWO_X_FOUR",
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            todoCategoryId,
            storecastId,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_TODO_SUMMARY_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables);
      } catch {}
    },
    300
  );

  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds);
    }, [teamIds, loadPreviewQuery])
  );

  return query;
}
